export default "__VITE_ASSET__6c80e2fe__"